// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import MuiLink from "@mui/material/Link";
// import MDButton from "components/MDButton";
// import { NavLink } from "react-router-dom";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// const spacing = 10;

// const info = [
//   {
//     maps: 'https://goo.gl/maps/KfVcbzART4yzBiG57',
//     title: "Lusowo",
//     address: 'ul. Skośna 9, 62-080 Lusowo',
//     color: "lusowo",
//   },
//   {
//     maps: 'https://goo.gl/maps/WYyFRtZSwuy4xJnQ6',
//     title: "Tarnowo Podgóme",
//     address: 'ul. Z. Romaszewskiego 4, 62-080 Tarnowo Podgóme',
//     color: "tarnowo",
//   },
//   {
//     maps: 'https://goo.gl/maps/C9UZJTgocPAa3Zrz8',
//     title: "Przeźmierowo",
//     address: 'ul. Składowa 45, 62-081 Przeźmierowo',
//     color: "przezmierowo",
//   },
// ]

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { TextPlusImage } from "components/AboutSectionComponents/textPlusImage";
import img1 from "../../assets/newGraphics/girl with flower.png";
import img2 from "../../assets/newGraphics/boy with car.png";
import img3 from "../../assets/newGraphics/girl painting rainbow.png";
import img4 from "../../assets/newGraphics/girl with a horse.png";
import img5 from "../../assets/newGraphics/boy_painting_sun.png";
import img6 from "../../assets/newGraphics/girl with a rocket.png";


function About() {

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox width="100%" margin={"auto"} >
        <MDBox px={{xs: 0, md: 4, xl: 16}} mt={{xs: 3, md: 15}} mb={{xs: 3, md: 15}} textAlign={'flex-start'}>
          <MDTypography variant={"h1"}>
            Witamy w Przedszkolu "Chatka Kubusia Puchatka"
          </MDTypography>
        </MDBox>
        <MDBox className='flex flex-col gap-y-8'
          px={{xs: 0, md: 4, xl: 16}}
          display="flex"
          flexDirection="column"
          gap={8}
        >
          <TextPlusImage
            imageOnRight 
            text={"Wkraczając do naszego przedszkola, otwieracie drzwi do magicznego świata przedszkolnej zabawy i nauki dla dzieci od 2,5 do 6 lat. Nasza kadra troszczy się o Wasze skarby w dni powszednie od 7 rano do 17 po południu. A co się w tym czasie dzieje? No cóż, zapewniamy nie tylko trzy pyszne posiłki, ale również pełne radości zajęcia edukacyjne, które uwzględniają baśnie, śpiew, taniec i kreatywne szaleństwa!"}
            imagePath={"/assets/images/boy with car.png"}
            image={img1}
          />
          <TextPlusImage
            imageOnRight={false}
            text={"Oczywiście, maluszki potrzebują czasem drzemki – a my mamy dla nich specjalne miejsce na wygodne leżaczki, by zyskały siłę do kolejnych przygód. Nasza ekipa profesjonalnych nauczycieli jest gotowa, by codziennie rozwijać uzdolnienia Waszych dzieciaków poprzez dodatkowe zajęcia. Czy to artystyczne perypetie, muzyczne szaleństwa czy odkrywanie języków – mamy to wszystko!"}
            imagePath={"/assets/images/girl with flower.png"}
            image={img2}
          />
          <TextPlusImage
            imageOnRight 
            text={"Wiemy, że małe brzuszki rosną, dlatego prowadzimy własną kuchnię, gdzie przygotowujemy świeże i zdrowe posiłki, które zachęcają do smakowania. Nasze Panie Kucharki to prawdziwe czarodziejki smaku, dbające o kulinarne przyjemności Waszych dzieci."}
            imagePath={"/assets/images/boy_painting_sun.png"}
            image={img3}
          />
          <TextPlusImage
            text={"U nas nie ma nudnych chwil – codziennie wychodzimy na spacery i bawimy się na przedszkolnym placu zabaw. Dzięki temu dzieciaki poznają świat wesoło i zdrowo! Nasi wspaniali podopieczni uczestniczą w zajęciach pełnych kreatywności, zgodnych z oficjalnym programem Ministerstwa Edukacji Narodowej. Ale to nie koniec atrakcji! Na porządku dziennym jest także język angielski, rytmika, taniec, sztuka i gotowanie w Klubie Małego Kucharza."}
            imagePath={"/assets/images/girl with a horse.png"}
            image={img4}
          />
          <TextPlusImage
            imageOnRight 
            text={"Dla nas liczy się nie tylko nauka, ale i rozwijanie pasji! Przedszkolaki uczą się liter i liczb poprzez świetną zabawę, a dzięki interaktywnym tablicom mulitmedialnym edukacja staje się prawdziwą przygodą.\n" +
                  "Znudziło się już? Nie ma mowy! Nasze przedszkola to miejsca, gdzie dzieje się magia. Wychowankowie spotykają się z artystami, zwiedzają świat teatru i tańca, a także świętują fantastyczne dni jak Dzień Pluszowego Misia czy Święto Marchewki. I to nie wszystko! Nasze małe gwiazdy wcielają się w role w przedstawieniach dla rodziców, udowadniając, że są prawdziwymi talentami!"}
            imagePath={"/assets/images/girl painting rainbow.png"}
            image={img5}
          />
          <TextPlusImage
            text={"Dla nas najważniejsze jest dobro Waszych pociech. U nas znajdziecie opiekę, cierpliwość i uśmiech, które pomogą w adaptacji Waszych maluchów. Ekipa doświadczonych pedagogów jest tu po to, by Wasze dzieci poczuły się jak w domu.\n" +
                  "Zapraszamy Was serdecznie do naszych Chatek Kubusia Puchatka – przedszkoli pełnych radości, nauki i przygód dla Waszych małych odkrywców!"}
            imagePath={"/assets/images/girl with a rocket.png"}
            image={img6}
          />
        </MDBox>
{/* 
        <MDBox maxWidth={1000} margin='auto'>
          <MDTypography>
            Przedszkole „Chatka Kubusia Puchatka” sprawuje opiekę nad dziećmi w wieku od 2,5 do 6 lat, w dni powszednie, w godzinach od 7.00 – 17.00. W tym czasie dzieci zjadają 3 posiłki, uczestniczą w zajęciach edukacyjnych urozmaiconych zabawą, śpiewem i tańcem. Maluszki, potrzebujące odpoczynku – leżakują w wyznaczonym czasie. Dla wszystkich zapisanych dzieci zajęcia dodatkowe odbywają się każdego dnia i są dużym wsparciem dla rozwoju uzdolnień plastycznych, muzycznych, językowych, a także w zdobywaniu umiejętności czytania i pisania. Stawiamy na pobudzanie ciekawości i wspieramy dzieci w wielostronnym rozwoju oraz zdobywaniu samodzielności. Codziennie wychodzimy na spacery lub korzystamy z przedszkolnego placu zabaw.
          </MDTypography>
          <MDTypography>
            Dysponujemy własną kuchnią. Posiłki podawane dzieciom przygotowywane są na miejscu, ze świeżych składników, według profesjonalnych jadłospisów. Panie Kucharki dokładają wszelkich starań by dzieciom wszystko smakowało. Zależy nam na tym, aby nasi podopieczni poszerzali swoje kulinarne upodobania. Wiemy, jak ważne dla ogólnego rozwoju jest to, żeby dzieci zdrowo i smacznie jadły, bo w przedszkolu nie próżnujemy.
          </MDTypography>
          <MDTypography>
            Dzieci uczęszczające do Przedszkola „Chatka Kubusia Puchatka” codziennie biorą udział w zajęciach dydaktycznych, zgodnych z programem nauczania zatwierdzonym przez Ministerstwo Edukacji Narodowej. Poza tymi określonymi przez program, prowadzone są również zajęcia z języka angielskiego, rytmiki i tańca, plastyczne połączone z elementami arteterapii, bajkoterapia oraz lekcje gotowania w Klubie Małego Kucharza. Codzienna poranna gimnastyka dodaje dzieciom energii oraz uczy właściwych nawyków prozdrowotnych. Dodatkowo prowadzone są indywidualne zajęcia logopedyczne z wykwalifikowanym neurologopedą. 
          </MDTypography>
          <MDTypography>
            Prowadzimy również obowiązkowe przygotowanie przedszkolne dla dzieci 6-letnich tzw. Zerówkę. 
          </MDTypography>
          <MDTypography>
            Najmłodsze przedszkolaki poznają alfabet na zajęciach prowadzonych zgodnie z metodą nauki czytania opracowaną przez I. Majchrzak. Starsze przedszkolaki uczą się w oparciu o Metodę Dobrego Startu M. Bogdanowicz oraz przy wykorzystaniu technik opracowanych przez E. Gruszczyk-Kolczyńską rozwijają matematyczne i logiczne myślenie. Dzieci uczą się poprzez zabawę i dlatego nieustannie towarzyszą im gry oraz przeróżne rozrywki. W każdym przedszkolu znajduje się interaktywna tablica mulitmedialna, z której dzieci korzystają podczas zajęć edukacyjnych. 
          </MDTypography>
          <MDTypography>
            Codziennie przedszkolaki spędzają aktywnie czas na świeżym powietrzu, korzystając z konstrukcji rekreacyjnych i sprzętów sportowych na naszych placach zabaw.  Podczas spacerów poznają okolicę przedszkola oraz inne ciekawe miejsca, uczestnicząc w wycieczkach pieszych oraz autokarowych. 
          </MDTypography>
          <MDTypography>
            W przedszkolu organizowane są spotkania z artystami, którzy wprowadzają naszych wychowanków w fascynujący świat muzyki, tańca oraz teatru. Goszczą u nas także reprezentanci różnych zawodów. Obchodzimy m.in. Dzień Babci i Dziadka, Dzień Mamy, Taty, Dzień Pluszowego Misia, Andrzejki, Dzień Dinozaura,  Święto Marchewki oraz innych zgodnie  z kalendarzem świąt obchodzonych w naszej „Chatce”. 
          </MDTypography>
          <MDTypography>
            Nasi wychowankowie rozwijają swoje talenty artystyczne biorąc udział w przedstawieniach, które wystawiają dla swoich najbliższych. 
          </MDTypography>
          <MDTypography>
            Przykładamy wszelkich starań, aby proces adaptacji dziecka do nowego miejsca i otoczenia przebiegł jak najbardziej spokojnie. Jeśli nowa sytuacja jest stresująca, mogą Państwo liczyć na nasze wsparcie, a przedszkolak na najlepszą opiekę, cierpliwość, sympatię i wyrozumiałość doświadczonych pedagogów.
          </MDTypography>
        </MDBox> */}

        {/* <Grid container alignItems="stretch" pl={{xs: 0, md: spacing}} pr={{xs: 0, md: spacing}}>
          <img width={'100%'} src={MainImage} alt='main image'/>
        </Grid>
        <Grid container alignItems="stretch" p={{xs: 0, md: spacing}}>
          <Grid item xs={12} md={4} mb={3} mt={{xs: 3, md: 0}}>
            <MDTypography fontSize={24} pr={3} textAlign={{xs: 'center', md: 'left'}} >
              Zapraszamy do naszych trzech kolorowych przedszkoli
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={8}>
            <img width={'100%'} src={SecondImage} alt='main image'/>
          </Grid>
        </Grid>
        <Grid container alignItems="stretch" pl={{xs: 0, md: spacing}} pr={{xs: 0, md: spacing}}>
          <MDTypography fontSize={24} textAlign="center">
            Nasze przedszkola są przyjazne dzieciom i ich rodzicom, z bogata oferta programowo edukacyina oraz licznymi zajeciami
            dodatkowymi. Pracuje u nas wykwalifikowana kadra pedagogiczna, a także specjalisci w zakresie prowadzenia gimnastyki
            korekcyinej, logopedii, rytmiki; filolodzy jezyka angielskiego; pasionaci uczacy dzieci tanca, nauki jazdy na nartach,
            plywania; artysci prowadzacy Klub Małego Muzyka, Prosinfonike, teatrzyki.
          </MDTypography>
          <MDBox mt={3} mb={3} display="flex" flex={1} justifyContent="center">
            <MDBox component={NavLink} to="/zapisy" mt={3}>
              <MDButton color="maintext">
                Zapisz swoje dziecko
              </MDButton>
            </MDBox>
          </MDBox>
        </Grid>
        <Grid container alignItems="stretch" p={{xs: 0, md: spacing}} mt={{xs: 3, md: 0}}>
          <Grid item xs={12} md={6} mb={3}>
            <MDTypography fontSize={24} pr={{xs: 0, md: 6}} textAlign={{xs: 'center', md: 'left'}}>
              Aby poznać nas lepiej i poczuć atmosferę panującą wewnątrz, zapraszamy do odwiedzin
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={6}>
            {info.map((location) => {
              return <>
                <MDTypography display="inline" variant="h3" fontWeight="bold">
                  {location.title}
                </MDTypography>
                <MuiLink href={location.maps} target="_blank" rel="noreferrer">
                  <MDBox mt={2} mb={4} display="flex" flexDirection="row" alignItems="center">
                    <LocationOnIcon color={location.color} fontSize="medium" />
                    <MDTypography variant="body2" component="p" color="text" pl={1}>
                      {location.address}
                    </MDTypography>
                  </MDBox>
                </MuiLink>
              </>
            })}
          </Grid>
        </Grid> */}

        {/* <MDTypography>
        Od 01.09.2015r. Przedszkole "Chatka Kubusia Puchatka" działa jako przedszkole publiczne.
        </MDTypography>
        <MDTypography>
        Tutaj dowiecie się Państwo prawie wszystkiego o naszych trzech kolorowych przedszkolach, ale aby poznać nas lepiej i poczuć atmosferę panującą wewnątrz, zapraszamy do odwiedzin.
        </MDTypography>
        <MDTypography>
        Przedszkole Niepubliczne „Chatka Kubusia Puchatka" rozpoczeto swoja dziatalnos w 2004 roku w gminie Tarnowo Podgóme z siedziba w Lusowie. Od 2006 roku dziala druga placówka w Tarnowie Podgornym, a od wrzesnia 2009 roku
        rozpoczelo swoja dziatalnosc trzecie przedszkole w Przezmierowie.
        Sa to placówki nowoczesne, pryjazne dzieciom i ich rodzicom, z bogata oferta programowo edukacyina oraz licznymi zajeciami dodatkowymi. Pracuje u nas wykwalifikowana kadra pedagogiczna, a take specjalisci w zakresie prowadzenia gimnastyki korekcyinej, logopedii, rytmiki; filolodzy jezyka angielskiego; pasionaci uczacy dzieci tanca, nauki jazdy na nartach, plywania; artysci prowadzacy Klub Matego Muzyka,
        Prosinfonike, teatrzyki.
        Nasze dzialania skupiamy wokói potencjalu tworczego dziecka. Pracujemy wediug podstawy programowej zatwierdzonej prez MEN. Korzystamy z najnowszych programów nauczania oraz wypracowanych metod iform pracy. Bogata oferte do stosowujemy do
        potrzeb rodziców oraz zainteresowan i zdolnosci dzieci.
        </MDTypography>
        <MDTypography>
        Pracujemy w godzinach 7.00 - 17.00. W tym czasie nasi mali podopieczni zjadają pyszne posiłki i uczestniczą w wielu zajęciach okraszonych przednią zabawą. Posiłki (śniadanie, obiad, podwieczorek) przygotowywane są na miejscu, według profesjonalnych jadłospisów i tylko ze świeżych składników, a Panie Kucharki dokładają wszelkich starań by dzieciom wszystko smakowało i aby poszerzały swoje kulinarne upodobania. Jest to bardzo ważne, żeby dzieci zdrowo i smacznie jadły, bo w „Chatce Kubusia Puchatka” nie próżnujemy. Codziennie dzieci uczestniczą w zajęciach dydaktycznych, opartych na podstawie programowej zatwierdzonej przez Ministerstwo Edukacji Narodowej, ale to podstawa. Dodatkowo 3-4 razy w tygodniu przedszkolacy pobierają lekcje języka angielskiego i 2 razy rytmiki, a raz w tygodniu chętni uczestniczą w  zajęciach katechezy. Wprowadziliśmy do naszych codziennych zajęć edukacyjnych metodę Dobrego Startu wg Marty Bogdanowicz, zajęcia matematyczne prowadzone metodą Edyty Gruszczyk Kolczyńskiej, wśród najmłodszych Odimienną Metodę Nauki Czytania Ireny Majchrzak. Oprócz profesjonalnych zajęć logopedycznych i indywidualnych spotkań z Panią logopedą, dzieci uczestniczą w zajęciach teatralnych wzbogaconych elementami logopedii, podczas których wyginają i łamią języki. Wszystkie przedszkolaki należą do kółka plastycznego wzbogaconego elementami arteterapii, a na koniec tygodnia wszyscy gotują w Klubie Małego Kucharza. Intensywnie rozwijamy się też ruchowo. Starsze dzieci grają na flażoletach, a wszyscy często bawią się z chustą animacyjną, metodami Klanzy. Dla wyciszenia prowadzimy bajkoterapię. Codziennie wychodzimy na plac zabaw, a czasem na dłuższe spacery, aby poznać najbliższą okolicę. 3 razy w roku wyjeżdżamy na całodniową wycieczkę. Zapraszamy do nas reprezentantów ciekawych zawodów i trupy teatralne. Co najmniej raz w miesiącu wystawiane jest dla przedszkolaków przedstawienie artystyczne, uczestniczymy w koncertach Pro Sinfonica, a w przedszkolu organizowany jest Klub Małego Muzyka, w ramach którego  zapraszamy tancerzy, instrumentalistów, śpiewaków. Poza tym wszystkim wychowujemy, oraz kształtujemy małe charaktery, wspierając ich indywidualny rozwój.
        </MDTypography>
        <MDTypography>
        Prowadzimy również obowiązkowe przygotowanie przedszkolne dla dzieci 6-letnich.
        </MDTypography> */}
    </MDBox>
    </DashboardLayout>
  );
}

export default About;
